import { useContext, useState, useCallback } from "react";
import { formatDateFromTimestampWeekday } from "../../../utils/helpers";
import { Button, Loading } from "@evertrue/et-components";
import { JourneysContext } from "apps/journeys/context/journeys-context";
import JourneyTaskCount from "./journey-task-count";
import OtherTaskCount from "./other-task-count";
import AddTaskButton from "apps/tasks/components/create/add-task-button";
import EverTrue from "app";
import HomepageCard from "../homepage-card";

const TodayContent = () => {
  const { loadingJourneys } = useContext(JourneysContext);
  const [refetchTasks, setRefetchTasks] = useState(false);

  const triggerReload = useCallback(() => {
    setRefetchTasks(true);
  }, []);

  const stopReload = useCallback(() => {
    setRefetchTasks(false);
  }, []);

  return (
    <HomepageCard
      leftHeading={"Today"}
      rightHeading={formatDateFromTimestampWeekday(Math.floor(new Date().getTime()))}
      body={
        <>
          {loadingJourneys ? <Loading /> : <JourneyTaskCount />}
          <div className="homepage-today-cadence-steps--view">
            <Button
              onClick={() => {
                EverTrue.UrlManager.navigate("/cadences", true, false);
              }}
            >
              View Cadences
            </Button>
          </div>
          <OtherTaskCount reload={refetchTasks} stopReload={stopReload} />
          <div className="homepage-today-other-tasks">
            <div className="homepage-today-other-tasks--view">
              <Button
                onClick={() => {
                  EverTrue.UrlManager.navigate("/tasks", true, false);
                }}
              >
                View Tasks
              </Button>
            </div>
            <div className="homepage-today-other-tasks--add">
              <AddTaskButton tertiary={true} primary={false} triggerReload={triggerReload} />
            </div>
          </div>
        </>
      }
    />
  );
};

export default TodayContent;
